export const structureDropdowns = {
  searchOptions: [
    { value: "similarity", label: "Similarity" },
    { value: "substructure", label: "Substructure" },
    { value: "exact", label: "Exact" },
    { value: "isomorphism", label: "Isomorphism" },
  ],
  composition: [
    { value: "il", label: "Ionizable Lipid" },
    { value: "hl", label: "Helper Lipid" },
    { value: "chl", label: "Cholesterol" },
    { value: "peg", label: "Peg Lipid" },
  ],
  subunit: [
    { value: "total", label: "Total" },
    { value: "head", label: "Head" },
    { value: "linker", label: "Linker" },
    { value: "tail1", label: "Tail1" },
    { value: "tail2", label: "Tail2" },
  ],
};
